import { Outlet } from 'react-router-dom';
import { ApplicationShell } from './admin-layout';
import { ProtectedRoute } from './protected-route';

export function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <ApplicationShell>
        <Outlet />
      </ApplicationShell>
    </ProtectedRoute>
  );
}
